import React, { useState, useEffect, useCallback } from "react";

// recoil
import { useRecoilValue, useSetRecoilState } from "recoil";
import { userCredentials, routeInfo } from "recoilState/GlobalState";

//Services
import { usuarioLugarHorarioDetalleGet } from "services/services-mia/miakey";

// utils
import XGrid from "components/UI/Grid/XGrid";
import { HeaderButton, Buttons } from "components";
import { Add, Cached, Delete } from "@mui/icons-material";

import Modal from "components/UI/Modal/Modal";
import { InsertModal, EliminarModal } from "./Actions";

// consts
import { dashboardAccesosEstados as titles } from "consts/titulos-de-tablas";
import { ACTIONS } from "consts/Actions";
import { Routes } from "consts/Routes-App";

// styles
import s from "styles/pages/Pages.module.scss"

export default function Estados({
    accesoDetailId,
    service,
    selectedRow,
    usuarioId,
    merchantServicioUsuarioId,
}) {
    const [isLoading, setIsLoading] = useState(true);
    const [rows, setRows] = useState([]);
    const [internalRowSelected, setInternalRowSelected] = useState({ status: false, row: {} });
    const [modalDetails, setModalDetails] = useState({ isOpen: false });

    const credentials = useRecoilValue(userCredentials);
    const setRoute = useSetRecoilState(routeInfo);

    const updateList = useCallback(async () => {
        setIsLoading(true);
        setRows([]);
        const { result } = await usuarioLugarHorarioDetalleGet({
            gateUsuarioLugarHorarioId: accesoDetailId
        }, credentials);
        setRows(result.map((item) => {
            const {
                gateUsuarioLugarHorarioId,
                gateUsuarioLugarHorarioStatus,
                gateUsuarioLugarHorarioFH,
                gateHorarioNombre,
                gateHorarioDescripcion,
                puedeEliminarse,
                gateUsuarioLugarHorarioVersion
            } = item;

            return {
                id: gateUsuarioLugarHorarioId,
                gateUsuarioLugarHorarioId,
                gateUsuarioLugarHorarioStatus,
                gateUsuarioLugarHorarioFH,
                gateHorarioNombre,
                gateHorarioDescripcion,
                puedeEliminarse,
                gateUsuarioLugarHorarioVersion,
                [titles[0].field]: gateUsuarioLugarHorarioFH,
                [titles[1].field]: gateHorarioNombre,
                [titles[2].field]: gateHorarioDescripcion,
                [titles[3].field]: gateUsuarioLugarHorarioStatus === "A" ? "Alta" : "Baja",
            }
        }));
        setIsLoading(false);
    }, [credentials, accesoDetailId]);

    useEffect(() => {
        setRoute(Routes.accesos)
    }, [setRoute])

    useEffect(() => {
        updateList()
    }, [service, updateList]);

    const closeModal = () => setModalDetails({ isOpen: false });

    const handleClick = ({ procede, title }) => {
        setModalDetails({ title, procede, isOpen: true });
    };

    return (
        <main className={s.main}>
            <Modal onClose={closeModal} open={modalDetails.isOpen} title={modalDetails.title}>
                {modalDetails.procede === ACTIONS.INSERT && (
                    <InsertModal
                        usuarioId={usuarioId}
                        merchantServicioUsuarioId={merchantServicioUsuarioId}
                        gateZonaId={selectedRow?.gateZonaId}
                        gateLugarId={selectedRow?.gateLugarId}
                        zonaNombre={selectedRow?.gateZonaNombre}
                        lugarNombre={selectedRow?.gateLugarNombre}
                        usuarioNombre={selectedRow?.usuario}
                        updateList={updateList}
                        closeModal={closeModal}
                    />
                )}
                {modalDetails.procede === ACTIONS.DELETE && (
                    <EliminarModal
                        selectedRow={internalRowSelected.row}
                        updateList={updateList}
                        closeModal={closeModal}
                    />
                )}
            </Modal>
            <div className={s.actions}>
                <Buttons>
                    <HeaderButton
                        text={"Actualizar"}
                        onClick={updateList}
                        disabled={internalRowSelected.row.id}
                    >
                        <Cached />
                    </HeaderButton>
                    <HeaderButton
                        text={"Agregar"}
                        handleClick={handleClick}
                        data={{
                            title: `Agregar Horario - ${selectedRow?.gateLugarNombre} - ${selectedRow?.usuario}`,
                            procede: ACTIONS.INSERT,
                        }}
                    >
                        <Add />
                    </HeaderButton>
                    <HeaderButton
                        text={"Eliminar"}
                        handleClick={handleClick}
                        data={{
                            title: `Eliminar Horario - ${selectedRow?.gateLugarNombre} - ${selectedRow?.usuario}`,
                            procede: ACTIONS.DELETE,
                        }}
                        disabled={internalRowSelected.row?.puedeEliminarse !== 'Y' }
                    >
                        <Delete />
                    </HeaderButton>
                </Buttons>
            </div>
            <div className={s.container}>
                <XGrid
                    rows={rows}
                    titles={titles}
                    loading={isLoading}
                    secondarySelected={internalRowSelected}
                    setSecondarySelected={setInternalRowSelected}
                />
            </div>
        </main>
    );
}
